import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { Badge, ImageContainer } from "./NotificationItemImage.styled";
const NotificationItemImage = React.memo((props) => {
    const { image, badgeIcon, imageBackgroundColor } = props;
    const isImage = typeof image === "string";
    return (_jsx(Badge, { overlap: "circular", anchorOrigin: {
            vertical: "bottom",
            horizontal: "left",
        }, badgeContent: badgeIcon, isImage: isImage, children: isImage ? (_jsx(ImageContainer, { backgroundColor: imageBackgroundColor, children: _jsx("img", { src: image, alt: "Notification Image" }) })) : (image) }));
});
export { NotificationItemImage };
//# sourceMappingURL=NotificationItemImage.js.map